import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button, Modal } from 'react-bootstrap';
import './TextLibraryPickerModal.css';
import TextLibraryPickerTable from './TextLibraryPickerTable.js';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import config from '../config';
import { Link } from 'react-router-dom';

class TextLibraryPickerModal extends Component {
    constructor(props) {
        super(props);

        this.handleHide = this.handleHide.bind(this);

        this.state = {
            show: false,
            title: 'Hello World',
            textlibraries: [],
            page: 1,
            pageCount: 0,
            limit: 10,
            search: '',
            organisationUUID: '',
            excludeIDs: [],
            itemsSelected: []
        };
    }

    handlePageClick = data => {
        let selected = data.selected + 1;
 
        this.setState({ page: selected }, () => {
            this.loadOrganisationTextLibrariesFromServer();
        });
    };

    handleHide() {
        this.props.onHide();
        this.setState({
            itemsSelected: []
        });
    }

    handleChooseClicked() {
        this.props.onChoose(this.state.itemsSelected);
        this.setState({
            itemsSelected: []
        });
    }

    componentDidMount() {}

    loadOrganisationTextLibrariesFromServer() {
        var self = this;

        axios
            .get(
                `${config.baseURL}/organisations/${
                    this.state.organisationUUID
                }/textlibraries`,
                {
                    params: {
                        page: self.state.page,
                        limit: self.state.limit,
                        excludeAttribute: self.state.excludeAttribute,
                        search: self.state.search
                    }
                }
            )
            .then(function(response) {
                self.setState({
                    textlibraries: response.data.textLibraries,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    componentWillReceiveProps(newProps) {
        this.setState(
            {
                show: newProps.show,
                title: newProps.title,
                organisationUUID: newProps.organisationUUID,
                excludeIDs: newProps.excludeIDs
            },
            () => {
                this.loadOrganisationTextLibrariesFromServer();
            }
        );
    }

    selectionChanged(textlibrary, checked) {
        let itemsSelected = this.state.itemsSelected;

        if (checked) {
            itemsSelected.push(textlibrary.uuid);
        } else {
            itemsSelected = itemsSelected.filter(
                selectedItem => selectedItem !== textlibrary.uuid
            );
        }

        var selectedSet = new Set(itemsSelected);

        this.setState({
            itemsSelected: [...selectedSet]
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="TextLibraryPickerModal">
                <Modal
                    show={this.state.show}
                    onHide={this.handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    dialogClassName="TextLibraryPickerModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">
                            {t('TextLibraryPickerModal.title')}{' '}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ margin: '0px', padding: '0px' }}>
                        <TextLibraryPickerTable
                            itemsSelected={this.state.itemsSelected}
                            textlibraries={this.state.textlibraries}
                            onDelete={() => {}}
                            onSelectionChanged={this.selectionChanged.bind(
                                this
                            )}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="text-center">
                            <ReactPaginate
                                previousLabel={t('Pagination.previous')}
                                nextLabel={t('Pagination.next')}
                                breakLabel={<Link to="#">...</Link>}
                                breakClassName={'break-me'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                            />
                        </div>
                        <div className="btn-toolbar pull-right">
                            <Button onClick={this.handleHide}>
                                {t('TextLibraryPickerModal.close')}
                            </Button>
                            <Button
                                disabled={this.state.itemsSelected.length === 0}
                                className="btn-primary"
                                onClick={this.handleChooseClicked.bind(this)}
                            >
                                {t('TextLibraryPickerModal.add_selected')}
                                {` (${this.state.itemsSelected.length})`}
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default translate('translations')(TextLibraryPickerModal);
